
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.194 2.392A1.14 1.14 0 1013.583.781L8 6.364 2.417.78A1.14 1.14 0 00.806 2.392l5.583 5.583-5.583 5.583a1.14 1.14 0 101.611 1.611L8 9.587l5.583 5.582a1.14 1.14 0 101.611-1.61L9.611 7.974l5.583-5.583z","fill":"#56BFC7"}})])
          )
        }
      }
    